//支払先情報登録フォーム
import React, { useEffect, useState } from 'react';
import '../pages/List.css';
import '../App.css';
import { Divider } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import 'date-fns';
import { useRecoilState } from 'recoil';
import { mainBlueColor } from '../GlobalState';

interface FormFieldData {
  bankName: string;
  branchName: string;
  selectedAccountType: number;
  accountNumber: string;
  accountName: string;
}

interface Props {
  index: number;
  formData: any;
  getFormData: (index: number, updatedValues: any) => void;
}

export const RegisterBankAccountForm: React.FC<Props> = ({
  formData,
  index,
  getFormData
}) => {
  const [mainColor] = useRecoilState(mainBlueColor);

  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        height: 60,
        alignItems: 'center',
        width: '100%'
      },
      inputContainer: {
        marginLeft: 10,
        marginRight: 10,
        paddingRight: 10,
        width: '100%'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        height: 60,
        alignItems: 'center'
      },
      textContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      input: {
        height: 40,
        width: '100%',
        borderColor: '#c1c1c1',
        borderWidth: 1
      },
      inputContainerSelectBox: {
        marginLeft: 10,
        marginRight: 13,
        width: '100%'
      },
      selectBoxStyle: {
        WebkitAppearance: 'menulist-button',
        backgroundColor: 'white',
        borderColor: '#c1c1c1',
        height: 48,
        width: '100%'
      }
    })
  );
  const classes = useStyles();
  return (
    <div>
      <div
        className='table-top-container-customer'
        style={{ backgroundColor: '#FFFFFF' }}
      >
        {index === 0 ? (
          <div
            style={{
              fontWeight: 'bold',
              padding: 15,
              paddingBottom: 0,
              fontSize: 24
            }}
          >
            支払先情報
          </div>
        ) : (
          <div
            style={{
              fontWeight: 'bold',
              padding: 15,
              paddingBottom: 0,
              fontSize: 24
            }}
          >
            　
          </div>
        )}
      </div>
      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>銀行名</div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainer}>
            <input
              value={formData.bankName}
              maxLength={30}
              onChange={text => {
                getFormData(index, { bankName: text.target.value });
              }}
              className={classes.input}
            />
          </div>
        </div>
      </div>
      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />

      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>支店名</div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainer}>
            <input
              value={formData.branchName}
              maxLength={20}
              onChange={text => {
                getFormData(index, { branchName: text.target.value });
              }}
              className={classes.input}
            />
          </div>
        </div>
      </div>

      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>口座種別</div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainerSelectBox}>
            <select
              value={
                formData.selectedAccountType
                  ? formData.selectedAccountType.toString()
                  : ''
              }
              onChange={text => {
                const selectedValue = parseInt(text.target.value, 10); // 数値に変換
                getFormData(index, { selectedAccountType: selectedValue }); // 正しい数値を渡す
              }}
              className={classes.selectBoxStyle}
              name='cars'
              id='cars'
              form='carform'
            >
              <option value=''>選択してください</option>
              <option value='1'>普通</option>
              <option value='2'>当座</option>
            </select>
          </div>
        </div>
      </div>

      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>口座番号</div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainer}>
            <input
              value={formData.accountNumber}
              min={0}
              max={99999999}
              onChange={text => {
                if (text.target.value.length <= 8) {
                  getFormData(index, { accountNumber: text.target.value });
                }
              }}
              className={classes.input}
            />
          </div>
        </div>
      </div>

      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
      <div className={classes.subContainer}>
        <div className={classes.textMainContainer}>
          <div className={classes.textContainer}>名義人</div>
        </div>
        <div className={classes.inputMainContainer}>
          <div className={classes.inputContainer}>
            <input
              value={formData.accountName}
              maxLength={80}
              onChange={text => {
                getFormData(index, { accountName: text.target.value });
              }}
              className={classes.input}
            />
          </div>
        </div>
      </div>
      <Divider style={{ backgroundColor: '#CCCCCC', marginLeft: 15 }} />
    </div>
  );
};
